<template>
  <div
    style="position:relative;display:flex;flex-direction: column;min-height: 100%;"
    :class="{ 'mobile-viewport': $vuetify.breakpoint.xs}"
  >
    <div
        style="text-align:left;z-index:4;background:white;"
    >
        <div
            v-if="xcase && xcase.case_type"
            style="display:flex;align-items: center;padding:25px;padding-top: var(--mobile-padding-top, 25px);"
        >
            <div
                v-if="xcase.case_type.icon"
            >
                <img
                    :src="getIconPath(xcase.case_type.id)"
                    style="aspect-ratio: 1/1; max-height: 65px;margin-right: 20px;"
                />
            </div>
            <div
                style="flex-grow: 1;"
            >
                <div
                    style="font-size: 24px;font-weight: bold;"
                >
                    {{ xcase.case_type.name }}
                </div>
                <div
                    v-if="xcase.case_title"
                    style="font-size: 16px;"
                >
                    {{ xcase.case_title }}
                </div>
                <div
                    v-if="xcase.case_number"
                    style="font-size: 16px;"
                >
                    {{ xcase.case_number }}
                </div>
            </div>
            <div
                v-if="xcase && xcase.checklist_items && activeChecklistItems().length > 0 && $vuetify.breakpoint.mdAndUp"
                style="border-radius: 20px;background: #F5F5F5;padding: 8px 16px;font-size: 14px;font-weight: 500;display: flex;align-items: center;"
            >
                <div style="margin: 12px 0;">
                    <v-progress-circular
                        :value="checklistPercentComplete()"
                        :size="48"
                        :width="8"
                        :color="getDomainInfo.primary_color || 'primary'"
                    />
                </div>
                <div
                    style="margin-left: 10px"
                >
                    <div
                        style="font-size: 14px;font-weight: 500;margin-left: 10px;"
                    >
                        {{ checklistPercentComplete() }}% Complete
                    </div>
                    <v-btn
                        small
                        :color="getDomainInfo.primary_color || 'primary'"
                        dark
                        @click="tabs = 3"
                    >
                        View Progress
                        <v-icon right>mdi-chevron-right</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>
        <v-tabs
            v-if="xcase && !loading && getDomainInfo && case_news"
            v-model="tabs"
            :slider-color="getDomainInfo.primary_color || 'primary'"
            color="white"
            style="border-top:unset;border-bottom: 1px solid rgba(0,0,0,0.1);"
            icons-and-text
        >
            <v-tab
                key="home"
            >
                Overview
                <v-icon>mdi-briefcase</v-icon>
            </v-tab>
            <v-tab
                key="forms"
            >
                Forms
                <v-icon>mdi-file-document-multiple</v-icon>
            </v-tab>
            <v-tab
                v-show="xcase && case_news.length > 0"
                key="news"
            >
                News
                <v-icon>mdi-newspaper</v-icon>
            </v-tab>
            <v-tab
                v-show="xcase && xcase.checklist_items && activeChecklistItems().length > 0"
                key="progress"
            >
                Progress
                <v-icon>mdi-progress-check</v-icon>
            </v-tab>
            <v-tab
                v-show="xcase && xcase.faq.length > 0"
                key="faq"
            >
                FAQ
                <v-icon>mdi-help-circle</v-icon>
            </v-tab>
        </v-tabs>
    </div>
    <div
        v-if="xcase && !loading && getDomainInfo && case_news"
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
    >
        <v-tabs-items
            v-model="tabs"
            style="background:transparent;overflow-x:hidden;margin-bottom: 50px;flex-grow: 1;"
        >
            <v-tab-item
                key="home"
            >
                <v-layout row wrap>
                    <v-flex xs12 sm6 md8>
                        <!-- 81 chars is length of tiptap html string with nothing added -->
                        <v-card
                            v-if="xcase.case_type.info && xcase.case_type.info.length > 81"
                            style="margin: 10px;max-height: 600px; overflow: auto;"
                        >
                            <v-card-text
                                style="display:flex;align-items:center;"
                            >
                                <div 
                                    v-html="xcase.case_type.info"
                                />
                            </v-card-text>
                        </v-card>
                        <div
                            v-if="case_news.length > 0"
                            style="margin: 10px;"
                        >
                            <NewsCard
                                v-for="article in case_news.slice(0, 1)"
                                :key="article.id"
                                :article="article"
                                :solo="true"
                                style="margin-bottom: 15px;"
                            />
                        </div>
                        <v-card
                            style="padding: 20px;margin: 10px;"
                        >
                            <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px;">
                                Incomplete Forms
                            </div>
                            <div v-if="availableForms.length > 0">
                                <v-card
                                    v-for="form in availableForms.slice(0, 3)"
                                    :key="form.id"
                                    class="form-card mb-2"
                                    style="cursor:pointer;"
                                    @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } })"
                                >
                                    <v-card-text style="display:flex;align-items:center;">
                                        <v-icon size="28" style="margin-right:10px;">mdi-file-document</v-icon>
                                        <div style="flex-grow:1;">
                                            <span style="font-weight:bold;">{{ form.name }}</span>
                                            <span v-if="form.party_name"> - {{ form.party_name }}</span>
                                            <span v-if="form.form_number" style="font-style:italic;font-weight:300;"> ({{ form.form_number }})</span>
                                        </div>
                                        <v-btn
                                            v-if="form.is_signing"
                                            color="warning"
                                            small
                                            depressed
                                        >
                                            Sign
                                        </v-btn>
                                        <v-btn
                                            v-else-if="form.is_new"
                                            color="green"
                                            dark
                                            small
                                            depressed
                                        >
                                            Start
                                        </v-btn>
                                        <v-btn
                                            v-else
                                            color="primary"
                                            small
                                            depressed
                                        >
                                            Open
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                                <div v-if="availableForms.length > 3" style="text-align:right;">
                                    <v-btn
                                        small
                                        color="primary"
                                        text
                                        @click="tabs = 1"
                                    >
                                        View All Forms
                                        <v-icon right>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <div v-else style="opacity:0.5;">No forms require your attention.</div>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <v-card
                            v-if="xcase && xcase.checklist_items && activeChecklistItems().length > 0"
                            style="margin: 10px;"
                        >
                            <div
                                style="font-size: 18px;font-weight: bold;margin-left: 20px;padding-top: 15px;"
                            >
                                Case Progress
                            </div>
                            <div>
                                <v-progress-linear
                                    :value="checklistPercentComplete()"
                                    :color="getDomainInfo.primary_color || 'primary'"
                                    height="20"
                                    rounded
                                >
                                    <strong>{{ checklistPercentComplete() }}% Complete</strong>
                                </v-progress-linear>
                            </div>
                            <div
                                v-if="incompleteChecklistItems().length > 0"
                            >
                                <div
                                    style="font-size: 14px;font-weight: bold;margin: 0 20px;margin-top:unset;"
                                >
                                    Incomplete Tasks
                                </div>
                                <v-list
                                    two-line
                                    subheader
                                >
                                    <v-list-tile
                                        v-for="item in incompleteChecklistItems().slice(0, 5)"
                                        :key="item.id"
                                    >
                                        <v-list-tile-content>
                                            <v-list-tile-title v-html="item.title"></v-list-tile-title>
                                            <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-icon
                                                v-if="checklistItemChecked(item.id)"
                                                color="green"
                                            >
                                                mdi-check-circle
                                            </v-icon>
                                            <v-icon
                                                v-else
                                                color="grey"
                                            >
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                                <div v-if="incompleteChecklistItems().length > 5" style="text-align:right;">
                                    <v-btn
                                        small
                                        color="primary"
                                        text
                                        @click="tabs = 3"
                                    >
                                        View All Tasks
                                        <v-icon right>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <div
                                v-else
                                style="text-align: center;opacity:0.5;padding: 20px;font-size: 16px;"
                            >
                                <v-icon
                                    color="green"
                                    size="48"
                                >
                                    mdi-check-circle
                                </v-icon>
                                <br />
                                All tasks are complete.
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-tab-item>
            <v-tab-item
                key="forms"
            >
                <v-flex
                    class="form-feed"
                    :class="{'mobile': $vuetify.breakpoint.smAndDown}"
                >
                    <div
                        v-if="availableForms.length == 0"
                    >
                        <div
                            class="last-message"
                            style="padding: 10px;margin:auto;font-size:16px;vertical-align:middle;text-align:center;opacity:0.3;z-index:0;border-radius: 10px;background-color: rgba(0,0,0,0.06);"
                        >
                            <div
                            >
                                <v-icon
                                    color="262626"
                                    size="72"
                                >
                                    mdi-tray
                                </v-icon>
                                <br />
                                <span><br /><b>No forms require your attention</b></span>
                            </div>
                        </div>
                    </div>
                    <v-layout
                        v-else
                        row
                        wrap
                    >
                        <v-flex
                            xs12
                        >
                            <div
                                style="font-size: 18px;display: flex;flex-direction: row;align-items: center;"
                            >
                                <div>
                                    <v-icon
                                        size="36"
                                    >
                                        mdi-chevron-down
                                    </v-icon>
                                </div>
                                <div>
                                    Incomplete Forms
                                </div>
                            </div>
                        </v-flex>
                        <v-flex
                            v-for="form in availableForms"
                            :key="form.id"
                            xs12
                            sm12
                            md12
                            lg6
                            class="standard-form-card"
                            :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                        >
                            <v-card    
                                class="form-card"
                                style="cursor:pointer;"
                                @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } })"
                            >
                                <v-card-text
                                    style="border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;justify-content: center;align-items: center;"
                                >
                                    <div
                                        style="padding-right: 10px;"
                                    >
                                        <v-icon
                                            size="36"
                                        >
                                            mdi-file-document
                                        </v-icon>
                                    </div>
                                    <div
                                        style="font-size: 16px;font-weight: bold;flex-grow: 1;"
                                    >
                                        {{form.name}}

                                        <span
                                            v-if="form.party_name"
                                            style="font-weight: bold;"
                                        >
                                            - {{form.party_name}}
                                        </span>
                                        <span
                                            v-if="form.form_number"
                                            style="font-style: italic;font-weight: 300;"
                                        >
                                            ({{form.form_number}})
                                        </span>
                                    </div>
                                    <v-btn
                                        v-if="form.is_signing"
                                        color="warning"
                                        small
                                        depressed
                                    >
                                        Sign Form
                                    </v-btn>
                                    <v-btn
                                        v-else-if="form.is_new"
                                        color="green"
                                        dark
                                        small
                                        depressed
                                    >
                                        Start Form
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        color="primary"
                                        small
                                        depressed
                                    >
                                        Open Form
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <div
                        style="margin-top: 20px;"
                    >
                        <v-layout
                            v-if="unavailableForms.length > 0"
                            row
                            wrap
                        >
                            <v-flex
                                xs12
                            >
                                <div
                                    style="font-size: 18px;display: flex;flex-direction: row;align-items: center;"
                                >
                                    <div>
                                        <v-icon
                                            size="36"
                                        >
                                            mdi-chevron-down
                                        </v-icon>
                                    </div>
                                    <div>
                                        Submitted Forms
                                    </div>
                                </div>
                            </v-flex>
                            <v-flex
                                v-for="form in unavailableForms"
                                :key="form.id"
                                xs12
                                sm12
                                md12
                                lg6
                                class="standard-form-card"
                                :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                            >
                                <v-card  
                                    class="form-card"
                                    style="cursor:pointer;"
                                    :to="{ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } }"
                                >
                                    <v-card-text
                                        style="border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;justify-content: center;align-items: center;"
                                    >
                                        <div
                                            style="padding-right: 10px;"
                                        >
                                            <v-icon
                                                size="36"
                                            >
                                                mdi-file-document
                                            </v-icon>
                                        </div>
                                        <div
                                            style="font-size: 16px;font-weight: bold;flex-grow: 1;"
                                        >
                                            {{form.name}}

                                            <span
                                                v-if="form.party_name"
                                                style="font-weight: bold;"
                                            >
                                                - {{form.party_name}}
                                            </span>
                                            <span
                                                v-if="form.form_number"
                                                style="font-style: italic;font-weight: 300;"
                                            >
                                                ({{form.form_number}})
                                            </span>
                                        </div>
                                        <v-btn 
                                            small
                                            depressed
                                            title="Download PDF of Completed Form"
                                            @click.prevent="downloadPdf(form)"
                                            style="min-width: unset;border-top-right-radius: unset;border-bottom-right-radius: unset;border-right: solid rgba(0,0,0,0.1) 1px;margin-right:unset;"
                                        >
                                            <v-icon>mdi-download</v-icon>
                                        </v-btn>
                                        <v-btn
                                            small
                                            depressed
                                            style="margin-left: unset;border-top-left-radius: unset;border-bottom-left-radius: unset;"
                                        >
                                            View Form
                                        </v-btn>>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-flex>
            </v-tab-item>
            <v-tab-item
                key="news"
            >
                <v-flex
                    v-if="case_news.length > 0"
                    class="news-feed"
                    :class="{'mobile': $vuetify.breakpoint.smAndDown}"
                >
                    <div
                        v-if="xcase && xcase.case_type"
                        style="font-size: 16px;font-weight: bold;padding-left: 5px;"
                    >
                        Latest {{ xcase.case_type.name }} News
                    </div>
                    <div
                        style="padding: 10px 0;"
                    >
                        <div
                            v-for="article in case_news"
                            :key="article.id"
                        >
                            <NewsCard
                                :article="article"
                                style="margin-bottom: 15px;"
                            />
                        </div>
                        <div
                            v-if="moreNews"
                            style="text-align: center;"
                        >
                            <v-btn
                                @click="newsPage = newsPage + 1;fetchNews()"
                                :disabled="loading_news"
                                :loading="loading_news"
                                depressed
                                color="primary"
                                dark
                            >
                                Load More Articles
                            </v-btn>
                        </div>
                    </div>
                </v-flex>
            </v-tab-item>
            <v-tab-item
                key="progress"
            >
                <v-flex
                    class="form-feed"
                    :class="{'mobile': $vuetify.breakpoint.smAndDown}"
                >
                    <div
                        v-if="xcase && xcase.checklist && activeChecklistItems().length > 0"
                    >
                        <div
                            style="font-size: 18px;font-weight: bold;margin-bottom: 15px;"
                        >
                            Case Progress
                        </div>
                        <v-alert
                            :value="true"
                            type="info"
                        >
                            Your case progress is updated by <span class="legalFoot" />. This may not reflect recent actions you have performed.
                        </v-alert>
                        
                        <v-list
                            two-line
                            subheader
                        >
                            <v-list-tile
                                v-for="item in activeChecklistItems()"
                                :key="item.id"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="item.title"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-icon
                                        v-if="checklistItemChecked(item.id)"
                                        color="green"
                                    >
                                        mdi-check-circle
                                    </v-icon>
                                    <v-icon
                                        v-else
                                        color="grey"
                                    >
                                        mdi-checkbox-blank-circle-outline
                                    </v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </div>
                    <div
                        v-else
                        style="text-align: center;opacity:0.3;padding: 50px;font-size: 16px;"
                    >
                        No progress checklist is available for this case.
                    </div>
                </v-flex>
            </v-tab-item>
            <v-tab-item
                key="faq"
            >
                <v-flex
                    class="form-feed"
                    :class="{'mobile': $vuetify.breakpoint.smAndDown}"
                >
                    <div
                        v-if="xcase && xcase.faq && xcase.faq.length > 0"
                    >
                        <div
                            style="font-size: 18px;font-weight: bold;margin-bottom: 15px;"
                        >
                            Frequently Asked Questions
                        </div>
                        <v-card
                            v-for="cat in xcase.faq.slice().sort((a, b) => a.order - b.order)"
                            :key="cat.id"
                            style="margin-bottom: 10px;font-weight: 500;font-size: 16px;padding: 10px;background-color: rgba(0,0,0,0.05);"
                        >
                            <div
                                style="margin-bottom: 10px;font-size: 18px;font-weight: bold;"
                            >
                                {{ cat.title }}
                            </div>
                            <v-expansion-panel
                                focusable
                                accordion
                                expand
                            >
                                <v-expansion-panel-content
                                    v-for="(item, index) in cat.entries"
                                    :key="item.id"
                                >
                                    <template v-slot:header>
                                        {{ item.title }}
                                    </template>
                                    <v-card-text
                                        class="grey lighten-3"
                                    >
                                        {{ item.text }}
                                    </v-card-text>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            
                        </v-card>
                    </div>
                    <div
                        v-else
                        style="text-align: center;opacity:0.3;padding: 50px;font-size: 16px;"
                    >
                        No FAQ is available for this case.
                    </div>
                </v-flex>
            </v-tab-item>
        </v-tabs-items>
    </div>
    <div
        v-else
        style="position: absolute;top: 0;left: 0;bottom:0;right:0;width: 100%;height: 100%;background: rgba(255,255,255,0.7);z-index:10;display: flex;justify-content: center;align-items: center;flex-direction: column;"
    >
        <v-progress-circular
            :size="$vuetify.breakpoint.xs ? 100 : 150"
            :width="$vuetify.breakpoint.xs ? 10 : 15"
            indeterminate
            :color="getDomainInfo.primary_color || 'primary'"
        />
        <h2
            style="margin-top: 20px;font-weight: normal;color: rgba(0,0,0,0.6);"
        >
            Loading your case...
        </h2>
    </div>
    <v-snackbar
        v-model="showNotice"
        :timeout="5000"
        bottom
    >
        {{ noticeText }}
        <v-btn color="pink" flat @click="showNotice = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3
import NewsCard from '../../NewsCard.vue'

export default {
    name: 'Forms',
    components: {
        NewsCard
    },
    data () {
        return {
            xcase: {},
            loading: false,
            loading_news: false,
            case_news: [],
            newsPage: 1,
            moreNews: false,
            tabs: 0,
            showNotice: false,
            noticeText: ''
        }
    },
    created () {
        this.fetchForms()
    },
    methods: {
        checklistOptionalAdded (id) {
            if (this.xcase && this.xcase.checklist) {
                const checkedEntry = this.xcase.checklist.find(c => c.item.id === id)
                return checkedEntry
            }
            return false
        },
        checklistItemChecked (id) {
            if (this.xcase && this.xcase.checklist) {
                const checkedEntry = this.xcase.checklist.find(c => c.item.id === id)
                return checkedEntry ? !!checkedEntry.value : false
            }
            return false
        },
        incompleteChecklistItems () {
            if (this.xcase && this.xcase.checklist_items) {
                return this.xcase.checklist_items.filter(i => !this.checklistItemChecked(i.id) && (!i.optional || (i.optional && this.checklistOptionalAdded(i.id))) )
            }
            return []
        },
        checklistPercentComplete () {
            if (this.xcase && this.xcase.checklist_items && this.xcase.checklist_items.length > 0) {
            const relevantItems = this.xcase.checklist_items.filter(
                i => !i.optional || (i.optional && this.checklistOptionalAdded(i.id))
            )
            const completed = relevantItems.filter(i => this.checklistItemChecked(i.id)).length
            return relevantItems.length > 0
                ? Math.round((completed / relevantItems.length) * 100)
                : 0
            }
            return 0
        },
        activeChecklistItems () {
            if (this.xcase && this.xcase.checklist_items) {
                return this.xcase.checklist_items.filter(i => !i.optional || (i.optional && this.checklistOptionalAdded(i.id)) )
            }
            return []
        },
        fetchForms () {
            this.loading = true
            api.userform.contactCases.get(this.$route.params.id)
                .then(data => {
                    this.xcase = data
                    this.loading = false
                    this.fetchNews()
                    if (this.$route.query.notice) {
                        this.noticeText = this.$route.query.notice
                        this.showNotice = true
                        this.$router.replace({'query': null})
                    }
                })
        },
        fetchNews () {
            if (!this.loading_news) {
                this.loading_news = true
                api.news.casenews.list({casetype: this.xcase.case_type.id, pageNum: this.newsPage})
                    .then((data) => {
                        if (data.next_page)
                            this.moreNews = true
                        else
                            this.moreNews = false
                        this.case_news = this.case_news.concat(data.results)
                    })
                    .finally(() => {
                        this.loading_news = false
                    })
            }
        },
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
        downloadPdf (form) {
          api.userform.userForm.downloadContactPdf(form.id)
            .then(response => {
              let blob = new Blob([response.data])
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = form.name + '.pdf'
              link.click()
            })
        }
    },
    computed: {
        ...mapGetters('userform', [
            'signedForms',
        ]),
        ...mapGetters('auth', [
            'getDomainInfo',
        ]),
        progressPercent () {
            return 60
        },
        availableForms () {
            var forms = []
            if (!this.loading)
                this.xcase.userforms.filter((form) => {
                    if ((!form.client_readonly || form.is_signing) && !this.signedForms.includes(form.id)) {
                        forms.push(form)
                    }
                })
            return forms
        },
        unavailableForms () {
            var forms = []
            if (!this.loading)
                this.xcase.userforms.filter((form) => {
                    if (form.client_readonly || this.signedForms.includes(form.id)) {
                        forms.push(form)
                    }
                })
            return forms
        }
    }
}
</script>

<style scoped>

    .mobile-viewport {
        max-height: calc(100vh - 56px - var(--mobile-padding-bottom, 0px)) !important;
        height: 100vh;
    }

    .standard-content {
        max-height: calc(100vh - 135px);
        height:100vh;
        overflow-y:auto;
        position: relative;
    }
    
    .mobile-content {
        position: relative;
        flex-grow: 1;
    }

    .form-card {
        position: relative;
    }

    .standard-form-card {
        padding-right: 15px;
        padding-top: 15px;
    }

    .mobile-form-card {
        padding-top: 15px;
        padding-right: 0 !important;
    }

    .news-feed {
        overflow-y: auto;
        z-index:9;
        align-self: stretch;
        padding: 10px;
    }

    .news-feed.mobile {
        order: 1;
        align-self: unset;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
    }

    .form-feed {
        padding: 15px;
    }

    .form-feed.mobile {
        order: 2;
    }
</style>